import lazyScreen from '../utils/lazyScreen';
const APRequests = lazyScreen(() => import('../pages/ap/APRequests/index.js'), 'pages/ap/APRequests/index.js');
const APRequest = lazyScreen(() => import('../pages/ap/APRequest/index.js'), 'pages/ap/APRequest/index.js');
const APOrder = lazyScreen(() => import('../pages/ap/APOrder/index.js'), 'pages/ap/APOrder/index.js');
const APOrders = lazyScreen(() => import('../pages/ap/APOrders/index.js'), 'pages/ap/APOrders/index.js');
const APReceive = lazyScreen(() => import('../pages/ap/APReceive/index.js'), 'pages/ap/APReceive/index.js');
const APReceives = lazyScreen(() => import('../pages/ap/APReceives/index.js'), 'pages/ap/APReceives/index.js');
const APReturn = lazyScreen(() => import('../pages/ap/APReturn/index.js'), 'pages/ap/APReturn/index.js');
const APReturns = lazyScreen(() => import('../pages/ap/APReturns/index.js'), 'pages/ap/APReturns/index.js');
const APCredit = lazyScreen(() => import('../pages/ap/APCredit/index.js'), 'pages/ap/APCredit/index.js');
const APCredits = lazyScreen(() => import('../pages/ap/APCredits/index.js'), 'pages/ap/APCredits/index.js');
const APInvoice = lazyScreen(() => import('../pages/ap/APInvoice/index.js'), 'pages/ap/APInvoice/index.js');
const APInvoices = lazyScreen(() => import('../pages/ap/APInvoices/index.js'), 'pages/ap/APInvoices/index.js');
const APImportCost = lazyScreen(() => import('../pages/ap/APImportCost/index.js'), 'pages/ap/APImportCost/index.js');
const APImportCosts = lazyScreen(() => import('../pages/ap/APImportCosts/index.js'), 'pages/ap/APImportCosts/index.js');
const APPayments = lazyScreen(() => import('../pages/ap/APPayments/index.js'), 'pages/ap/APPayments/index.js');
const APAgingReport = lazyScreen(() => import('../pages/ap/APAgingReport/index.js'), 'pages/ap/APAgingReport/index.js');
const APSupplierStatement = lazyScreen(() => import('../pages/ap/APSupplierStatement/index.js'), 'pages/ap/APSupplierStatement/index.js');
const APBalance = lazyScreen(() => import('../pages/ap/APBalance/index.js'), 'pages/ap/APBalance/index.js');
const APQuotations = lazyScreen(() => import('../pages/ap/APQuotations/index.js'), 'pages/ap/APQuotations/index.js');
const APQuotation = lazyScreen(() => import('../pages/ap/APQuotation/index.js'), 'pages/ap/APQuotation/index.js');

export default [
    {
        path: '/ap/APRequest/:code',
        component: APRequest
    },
    {
        path: '/ap/APRequests',
        component: APRequests
    },
    {
        path: '/ap/APOrder/:code',
        component: APOrder
    },
    {
        path: '/ap/APOrders',
        component: APOrders
    },
    {
        path: '/ap/APReceive/:code',
        component: APReceive
    },
    {
        path: '/ap/APReceives',
        component: APReceives
    },
    {
        path: '/ap/APReturn/:code',
        component: APReturn
    },
    {
        path: '/ap/APReturns',
        component: APReturns
    },
    {
        path: '/ap/APCredit/:code',
        component: APCredit
    },
    {
        path: '/ap/APCredits',
        component: APCredits
    },
    {
        path: '/ap/APInvoice/:code',
        component: APInvoice
    },
    {
        path: '/ap/APInvoices',
        component: APInvoices
    },
    {
        path: '/ap/APImportCost/:code',
        component: APImportCost
    },
    {
        path: '/ap/APImportCosts',
        component: APImportCosts
    },
    {
        path: '/ap/APPayments',
        component: APPayments
    },
    {
        path: '/ap/APAgingReport',
        component: APAgingReport
    },
    {
        path: '/ap/APSupplierStatement',
        component: APSupplierStatement
    },
    {
        path: '/ap/APBalance',
        component: APBalance
    },
    {
        path: '/ap/APQuotation/:code',
        component: APQuotation
    },
    {
        path: '/ap/APQuotations',
        component: APQuotations
    },
    // {
    //     path: '/ap/APVendorPromotion/:code',
    //     component: APVendorPromotion
    // },
    // {
    //     path: '/ap/APVendorPromotions',
    //     component: APVendorPromotions
    // }
];
